export const projects = [
	{
		title: "Hello world",
		subtitle: "HTML",
		description:
			"This is just our first hello world page",
		image: "https://media.tenor.com/yheo1GGu3FwAAAAC/rick-roll-rick-ashley.gif",
		link: "https://naughtylittlegays.nekonyan.fun/hello-world/"
	},
	{
		title: "Whiz Quiz",
		subtitle: "React and Python",
		description:
			"Create your own interesting quizzes, and share 'em with your friends",
		image: "https://media.tenor.com/yheo1GGu3FwAAAAC/rick-roll-rick-ashley.gif",
		link: "https://example.com"
	},
	{
		title: "Matchmaker",
		subtitle: "Python Flask",
		description:
			"A simple matchmaker app written in Python's Flask framework",
		image: "https://media.tenor.com/yheo1GGu3FwAAAAC/rick-roll-rick-ashley.gif",
		link: "https://stackoverflow.com"
	}
];

export const skills = [
	{
		key: "HTML",
		title: "HTML",
		description:
			"HTML is a language that we've used to develop some of our website structures. The HTML is embedded within the JavaScript files in our React.js framework.",
		image: "./skill-1.gif",
		link: "https://google.com"
	},
	{
		key: "CSS",
		title: "CSS",
		description:
			"CSS is a language that we've used to create the styles, formatting and animations for our webpages.",
		image: "./skill-2.gif",
		link: "https://nhentai.net"
	},
	{
		key: "JavaScript",
		title: "JavaScript",
		description:
			"JavaScript is the main language for developing our website. All the data and components have been written in JavaScript files, which contain embedded HTML code.",
		image: "./skill-3.gif",
		link: "https://hanime.tv"
	},
	{
		key: "React",
		title: "React",
		description:
			"React.js is a JavaScript framework that we're mainly using to develop our webpages.",
		image: "./skill-4.gif",
		link: "https://pornhub.com"
	},
	{
		key: "Python",
		title: "Python",
		description:
			"Python is a language that we're using for writing the base of our applications. We combine it with HTML, CSS and JavaScript to allow it to run on a website.",
		image: "./skill-5.gif",
		link: "https://xnxx.com"
	}
];

export const testimonials = [
	{
		name: "John Doe",
		title: "CEO",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
		image: "./testimonial-1.gif",
		company: "Company Name",
		quote: "I love hentai!"
	},
	{
		name: "Jane Doe",
		title: "CTO",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
		image: "./testimonial-2.gif",
		company: "Google",
		quote: "I am definitely not gay."
	},
	{
		name: "Joe Doe",
		title: "COO",
		description:
			"Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
		image: "./testimonial-3.gif",
		company: "NaughtyLittleGays",
		quote: "what"
	}
];

export const developers = [
	{
		name: "Swan Tayza Aung",
		discord: "Yoinkman#1387",
		phone: "+959263609160",
		role: "idk what role to put here yet"
	},
	{
		name: "Nyan Lin Htut @ Quincy",
		discord: "QuincyNyan#6822",
		phone: "<nyan's phone here>",
		role: "idk what role to put here yet"
	},
	{
		name: "Amara Zin",
		discord: "Amaraa#7857",
		phone: "<amara's phone here>",
		role: "idk what role to put here yet"
	}
]